import { BookOpenCheck, FileText, MessageCircle, Route } from "lucide-react";

const stats = [
  { icon: Route, value: "Doorlopend", label: "opgebouwd over schooljaren" },
  { icon: FileText, value: "Eén dossier", label: "alles rond de leerling bij elkaar" },
  { icon: MessageCircle, value: "Menselijk", label: "de mentor blijft in gesprek" },
  { icon: BookOpenCheck, value: "Praktisch", label: "aansluitend op de LOB-les" },
];

const TrustStripSection = () => {
  return (
    <section className="border-b border-border bg-gradient-to-r from-accent via-background to-accent">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6 py-8">

        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="max-w-xs text-center lg:text-left">
            <p className="text-sm font-extrabold text-secondary">De hele LOB-reis in samenhang</p>
            <p className="mt-1 text-xs text-muted-foreground">Van eerste ontdekking tot een onderbouwde vervolgstap.</p>
          </div>

          {/* stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 lg:gap-10">
            {stats.map((s) => (
              <div key={s.label} className="text-center lg:text-left">
                <s.icon className="mx-auto mb-2 h-4 w-4 text-primary lg:mx-0" />
                <div className="text-sm font-extrabold text-secondary leading-none">{s.value}</div>
                <div className="text-xs text-muted-foreground mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStripSection;
